import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { getParams } from '../../common/utils';
import { repiActions, repiSearchRegexps } from '../../../store/repiStore';
import { getPoolGroup } from '../repiUtils';
import { popupActions } from '../../../store/popupStore';
import { reportActions } from '../../../store/reportStore';
import { PdfExportButton } from '../../common/refButtons';
import { isNullOrUndefined, capitalize, isFunction } from '../../../store/storeFunctions';
import BbDatePicker from '../../common/datePicker';

import './repiReportManager.scss';

class RepiReportManager extends React.Component {
    constructor(props) {
        super(props);
        const params = getParams(window.location.search);
        let calcDate = new Date();
        if (!isNullOrUndefined(params.calculationDate))
            calcDate = this.props.convertDate(params.calculationDate, new Date());

        this.state = {
            calculationDate: calcDate,
            isCalculationDateValid: true
        };
    }

    render() {
        const { reportType, subjectId } = this.props.getRepiProps();

        return (
            <div className="repi-report-manager-container">
                {this.renderLeft(reportType, subjectId)}
                {this.renderRight(reportType, subjectId)}
            </div>
        );
    }

    renderLeft = (reportType, subjectId) => {
        return (
            <div className="ref-buttons">
                {this.renderBackToCribisButton(subjectId)}
                {this.renderCalculationDatePicker(reportType)}
            </div>
        )
    }

    renderRight = (reportType, subjectId) => {
        const poolGroup = getPoolGroup();

        return (
            <div className='search-pdf-export' style={{ paddingRight: "0" }}>
                <div className='references print-hidden'>
                    <div className="ref-buttons">
                        <PdfExportButton onClick={() => this.props.exportRepiReportPdf(reportType, subjectId, poolGroup, this.state.calculationDate)} />
                    </div>
                </div>
            </div>
        );
    }

    renderCalculationDatePicker = (reportType) => {
        const { onCalculationDateSubmit } = this.props;
        if (!isFunction(onCalculationDateSubmit))
            return <div/>;

        return (
            <div className="calculation-date-wrapper">
                <div>
                    <Translate id="Repi.Report.CalculationDate" />
                </div>
                <div>
                    <BbDatePicker allowInvalidValues
                        id="calculationDate"
                        afterDateChange={(day, isValid) => this.onClaculationDateChange(day, isValid)}
                        value={this.state.calculationDate}
                        style={{ maxWidth: "12em", margin: "0 auto" }}
                        yearsBack={30}
                        disabled={false}
                    />
                </div>
                <div>
                    <button className={classnames("bb-button small gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                        disabled={!this.state.isCalculationDateValid}
                        onClick={() => onCalculationDateSubmit(reportType, capitalize(reportType), this.state.calculationDate)}>
                        <span><strong><Translate id="Repi.Report.UseCalculationDate" /></strong></span>
                    </button>
                </div>
            </div>
        );
    }

    renderBackToCribisButton = (subjectId) => {
        const params = getParams(window.location.search);
        if (isNullOrUndefined(params.source) || params.source !== "cribis")
            return null;

        const info = this.props.subjectInfos[subjectId];
        if (isNullOrUndefined(info) || info.isRequesting || isNullOrUndefined(info.result) || info.result.subjectType < 2
            || (info.result.isPin && !repiSearchRegexps.pin.test(info.result.identification.trim()))
            || (!info.result.isPin && (isNullOrUndefined(info.result.identification) || info.result.identification === "") || !repiSearchRegexps.id.test(info.result.identification.trim())))
            return null;

        return (
            <div id="repi-back-to-cribis"
                className="ref-button ref-pdfExport right-border"
                title={this.props.translate("Repi.BackToCribis")}
            >
                <a className={classnames('link-functional hide-on-mobile', { 'is-normal': localStorage.locales_url_format === 'normal' })}
                    href={`/search/results?type=bs&isPo=true&q=${info.result.identification}`}
                >
                    <Translate id="Repi.BackToCribis" />
                </a>
                <FontAwesomeIcon icon="share" className='search-result-icon svg-standard-fill' />
            </div>
        );
    }

    onClaculationDateChange = (date, isValid) => {
        if (date === "") // Empty date is considered as valid, but in this case it must be set
            this.setState({ isCalculationDateValid: false });
        else if (isValid)
            this.setState({ calculationDate: this.props.convertDate(date, new Date()), isCalculationDateValid: true });
        else
            this.setState({ isCalculationDateValid: false });
    }
}

export default withRouter(withLocalize(connect(
    state => ({ report: state.report, subjectInfos: state.repi.subjectInfos }),
    dispatch => bindActionCreators({ ...repiActions, ...reportActions, ...popupActions }, dispatch)
)(RepiReportManager)));
